import { Type } from 'class-transformer';
import { ContactResultDto } from './contact-result-dto';
import { ContactInfoFieldHeaderResultDto } from './contact-info-field-header-result-dto';

export class ContactInfoResultDto {
  @Type(() => ContactResultDto)
  contacts: Array<ContactResultDto> = [];

  @Type(() => ContactInfoFieldHeaderResultDto)
  phoneDataFields: Array<ContactInfoFieldHeaderResultDto> = [];

  @Type(() => ContactInfoFieldHeaderResultDto)
  emailDataFields: Array<ContactInfoFieldHeaderResultDto> = [];
}
